import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import request from '@utils/axiosWrapper';
import * as Ids from '@utils/ids';

import store from '../../../store';

const POLLING_INTERVAL = 60 * 60 * 1000;

/** 未读站内信数量轮询 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            request
                .postAsFormSubmit<
                    Array<{
                        categoryName: string;
                        categoryType: number;
                        categoryUnreadCount: number;
                        categorySort: number;
                    }>
                >('/gw/v2/shop/msgbox/category/unreadcount', {
                    wmPoiId: Ids.getWmPoiId(),
                    token: Ids.getToken(),
                    acctId: Ids.getAcctId(),
                    appType: 3,
                })
                .then(res => {
                    let totalCount = 0;
                    res.forEach(category => {
                        if (category.categoryType !== -2) {
                            totalCount += category.categoryUnreadCount;
                        }
                    });

                    store.dispatch({
                        type: 'shellHeader/updateUnReadNotificationCount',
                        payload: totalCount,
                    });
                });
        });
};

export default { init };
